import combineReducers from 'redux/lib/combineReducers';

import info from './info';

export default combineReducers({
  info,
});
